import { useState, useEffect } from 'react';

export const useSyncedInterval = () => {
  const [syncedIntervalCounter, setSyncedIntervalCounter] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      if (now.getSeconds() === 0) {
        setSyncedIntervalCounter((prevMinute) => prevMinute + 1);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return syncedIntervalCounter;
};
